import { FC } from 'react';

import { SetupAccountPage } from '../setup-account-page';

const GetStartedPage: FC = () => <SetupAccountPage />;

export { GetStartedPage };
